import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <g strokeLinecap="round" strokeWidth={1.2}>
      <path
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M4.051 8.53s-.14-2.418 1.01-2.476c1.152-.057 13.901-.547 15.053.23.365.26 1.01 2.305-.422 2.362-1.432.029-15.304.317-15.557 3.6-.252 3.283-.207 6.021.624 7.142.83 1.121 14.175 1.008 15.242 0 1.123-1.065.615-8.693.615-8.693"
      />
      <path
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="m8.73 5.95.409-1.09c.204-.506.758-.86 1.37-.86h3.53c.554 0 1.079.278 1.312.734l.38.766"
      />
      <path
        d="m9.862 14.496 4.993.262M12.228 17.124l.262-4.993"
        style={{
          stroke: "var(--icon-accent,#E47B53)",
        }}
      />
    </g>
  </svg>
);
export const Psychotherapy02Icon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
